<template>
    <table class="table table-bordered table-striped" aria-label="Driver fees list">
        <thead>
        <tr>
            <th style="width: 50%;">Årsag</th>
            <th style="width: 15%;">Beløb</th>
            <th>Stk</th>
            <th class="text-right" style="width: 5%"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in items" :key="index">
            <td style="width: 50%;">
                <input
                    :value="item.reason"
                    @input="$emit('update-item', { index, field: 'reason', value: $event.target.value })"
                    class="form-control"
                    type="text"
                >
                <div class="text-danger mb-1" v-if="errors[`${errorPrefix}.${index}.reason`]"><!-- eslint-disable-line vue/no-v-html -->
                    {{ errors[`${errorPrefix}.${index}.reason`][0] }}
                </div>
            </td>
            <td style="width: 15%;">
                <div class="d-flex align-items-center justify-content-center">
                    <input
                        :value="item.price"
                        @input="$emit('update-item', { index, field: 'price', value: $event.target.valueAsNumber ?? Number($event.target.value) })"
                        class="form-control"
                        type="number"
                    >
                    <span class="ml-2">{{ currencyLabel }}</span>
                </div>
                <div class="text-danger mb-1" v-if="errors[`${errorPrefix}.${index}.price`]"><!-- eslint-disable-line vue/no-v-html -->
                    {{ errors[`${errorPrefix}.${index}.price`][0] }}
                </div>
            </td>
            <td>
                <input
                    :value="item.stk"
                    @input="$emit('update-item', { index, field: 'stk', value: $event.target.value })"
                    class="form-control"
                    type="text"
                >
                <div class="text-danger mb-1" v-if="errors[`${errorPrefix}.${index}.stk`]"><!-- eslint-disable-line vue/no-v-html -->
                    {{ errors[`${errorPrefix}.${index}.stk`][0] }}
                </div>
            </td>
            <td>
                <span class="material-icons-outlined text-primary cursor-pointer"
                      title="Remove"
                      @click="$emit('remove', index)"
                >delete</span>
            </td>
        </tr>
        <tr>
            <td colspan="4" class="text-center">
                <div class="mt-3">
                    <span class="material-icons-outlined text-primary cursor-pointer"
                          :title="addTitle"
                          @click="$emit('add')"
                    >add_circle</span>
                </div>
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    name: 'DriverFeesList',
    props: {
        items: { type: Array, required: true },
        errors: { type: Object, default: () => ({}) },
        errorPrefix: { type: String, required: true },
        currencyLabel: { type: String, default: 'kr.' },
        addTitle: { type: String, default: 'Add' },
    },
}
</script>

<style scoped>
</style>
